const SingleShopTheLook = {
  parts: [
    'container',
    'imageContainer',
    'mainImage',
    'overlay',
    'actionButtons'
  ],

  baseStyle: {
    container: {
      position: 'relative',
      width: 'full',
      mx: 'auto',
      overflow: 'hidden',
      px: {base: 5, lg: 0},
      py: {base: 5, lg: 0},
    },

    imageContainer: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    mainImage: {
      width: 'full',
      objectFit: 'cover',
      objectPosition: 'center',
    },

    overlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: {base: '68px', md: '84px'}, // 68px mobile to match Figma
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      p: {base: 3, md: 5},
      gap: 1,
    },

    actionButtons: {
      display: 'flex',
      gap: 1,
      alignItems: 'center',
    },
  },

  variants: {
    default: {
      container: {
        sx: {
          'main & + *': {
            pt: {base: 5, lg: 20},
          },
        },
      },
    },
    boxy: {
      container: {
        px: {base: 5, lg: 20},
        py: {base: 5, lg: 20},
        maxWidth: '1440px',
        mx: 'auto',
      },
    },
  },
};

export default SingleShopTheLook;
